// extracted by mini-css-extract-plugin
export default {"wrap":"SsoLogin_wrap__ep7-J","title":"SsoLogin_title__quSCT"};